import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

type Pinprops = {
  status?: "pin" | "unpin" | "add";
} & WrappingIconProps;

export const PinIcon = ({ status = 'pin', ...props }: Pinprops) => {
  return (
    <Icon {...props}>
      <path
        d="M9 4.28427V9.28427L7 12.2843V14.2843H17V12.2843L15 9.28427V4.28427"
        stroke="var(--mode-vector-neutral-strong)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.2843V20.2843"
        stroke="var(--mode-vector-neutral-strong)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4.28427H16"
        stroke="var(--mode-vector-neutral-strong)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {status === "unpin" && (
        <path
          d="M8 21H15.5"
          stroke="var(--mode-vector-neutral-strong)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {status === "add" && (
        <g>
          <path
            d="M17.3787 18.0858H21.6213"
            stroke="var(--mode-vector-neutral-strong)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 20.2071V15.9645"
            stroke="var(--mode-vector-neutral-strong)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      )}
    </Icon>
  );
};
